// extracted by mini-css-extract-plugin
export var active = "CoursesToc-module__active___PUt+-";
export var compact = "CoursesToc-module__compact___v0M5n";
export var duration = "CoursesToc-module__duration___3yR8k";
export var icon = "CoursesToc-module__icon___7s9fC";
export var labBadge = "CoursesToc-module__labBadge___REa83";
export var lesson = "CoursesToc-module__lesson___kgAQl";
export var lessonList = "CoursesToc-module__lessonList___ljnij";
export var moduleBlock = "CoursesToc-module__moduleBlock___lAnpN";
export var moduleLabel = "CoursesToc-module__moduleLabel___HSRWu";
export var title = "CoursesToc-module__title___Ah4Mk";
export var toc = "CoursesToc-module__toc___pSDUK";
export var tocHeader = "CoursesToc-module__tocHeader___i1m8l";
export var withBg = "CoursesToc-module__withBg___p+Car";